<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>运营中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">入离职记录</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsWorkerDetail">
      <section class="searchBox">
        <div>
          <a-button
            style="
              background: #fff;
              color: rgba(0, 0, 0, 0.65);
              border: 1px solid #d9d9d9;
            "
            v-show="!showIsSearch"
            @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button
            style="
              background: #fff;
              color: rgba(0, 0, 0, 0.65);
              border: 1px solid #d9d9d9;
            "
            v-show="showIsSearch"
            @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </div>
        <div v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="isShowTwo">
          <label>省级项目：</label>
          <a-select
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </div>
        <div>
          <label>项目：</label>
          <a-select
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="showIsSearch">
          <label>来源渠道:</label>
          <a-select
            defaultValue="全部"
            v-model="resume_source"
            style="min-width: 120px"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, i) in formList"
              :key="i"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="showIsSearch">
          <label>工作类型:</label>
          <a-radio-group v-model="work_type">
            <a-radio :value="1">长期工</a-radio>
            <a-radio :value="2">临时工</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <label>是否在职:</label>
          <a-radio-group v-model="on_job">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <label>状态：</label>
          <a-select
            showSearch
            v-model="status"
            :filterOption="filterOption"
            placeholder="请选择状态"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in statusList"
              :key="i"
              >{{ item.txt }}</a-select-option
            >
          </a-select>
        </div>
        <div v-show="showIsSearch">
          <label>是否实名认证:</label>
          <a-radio-group v-model="is_authentication">
            <a-radio :value="1">已认证</a-radio>
            <a-radio :value="2">未认证</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <label>是否有待签合同:</label>
          <a-radio-group v-model="is_sign_contract">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <label>资料是否审核:</label>
          <a-radio-group v-model="is_aexamine">
            <a-radio :value="1">待审核</a-radio>
            <a-radio :value="2">审核通过</a-radio>
            <a-radio :value="3">已驳回</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <label>是否绑定亲属卡:</label>
          <a-radio-group v-model="is_relatives_card">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <label>离职是否结算:</label>
          <a-radio-group v-model="is_settlement">
            <a-radio :value="2">结算</a-radio>
            <a-radio :value="1">不结算</a-radio>
          </a-radio-group>
        </div>
        <div v-show="showIsSearch">
          <a-select v-model="date_type" style="width: 120px;margin-right:6px;">
            <a-select-option :value="1">入职日期</a-select-option>
            <a-select-option :value="2">入职操作日期</a-select-option>
            <a-select-option :value="3">离职日期</a-select-option>
            <a-select-option :value="4">离职操作日期</a-select-option>
          </a-select>
          <a-range-picker
            style="width:200px"
            v-model="dateVal"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </div>
        <div v-show="showIsSearch">
          <a-select
            v-model="operation_type"
            style="width: 120px;margin-right:6px;"
          >
            <a-select-option :value="1">入职操作人</a-select-option>
            <a-select-option :value="2">离职操作人</a-select-option>
          </a-select>
          <a-select
            style="width: 120px; margin-right: 6px"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
            v-model="operation_user_id"
          >
            <a-select-option
              v-for="(element, k) in userList"
              :key="k"
              :value="element.id"
              >{{ element.user_name }}</a-select-option
            >
          </a-select>
        </div>
        <div>
          <label>字符串：</label>
          <a-input
            style="width:220px"
            v-model="query_field"
            placeholder="姓名/手机号/身份证号/来源详情"
          />
        </div>
        <div>
          <a-button
            v-show="showIsSearch"
            style="margin-right: 10px"
            @click="onDownload"
          >
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button style="margin-right: 10px" @click="clearSearch"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </div>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.project_name }}</td>
              <td>
                <p v-show="item.work_type == 1">长期工</p>
                <p v-show="item.work_type == 2">临时工</p>
              </td>
              <td>
                {{ item.entry_time.substring(0, 10) }}
              </td>
              <td>
                <p v-show="item.status == 9">待认证</p>
                <p v-show="item.status == 10">待签约</p>
                <p v-show="item.status == 11">新合同待签</p>
                <p v-show="item.status == 20">资料待审核</p>
                <p v-show="item.status == 31">资料不合格</p>
                <p v-show="item.status == 40">已入职</p>
                <p v-show="item.status == 50">离职合同待签</p>
                <p v-show="item.status == 51">已离职</p>
                <p v-show="item.status == 0">未知</p>
              </td>
              <!-- <td>
                <p v-show="item.status == 50 || item.status == 51">
                  {{ item.leave_time.substring(0, 10) }}
                </p>
              </td> -->
              <td>{{ item.resume_source_info.type }}</td>
              <td>{{ item.resume_source_info.channel }}</td>
              <td>{{ item.resume_source_info.details }}</td>
              <td class="operation">
                <!-- v-show="userOperation" -->
                <!-- <a @click="changeChannelPage(item)">改渠道</a> -->
                <a style="color:#888" @click="detailPage(item.id)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 改渠道 -->
    <changeChannel
      v-show="showIsChangeChannel"
      :changeChannelDetail="changeChannelDetail"
      v-on:hideIsChangeChannel="hideIsChangeChannel"
    />
    <!-- 改渠道 end -->
    <!-- 详情 -->
    <workerDetail v-show="showIsWorkerDetail" :entry_id="entry_id" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import changeChannel from "@/components/worker/changeChannel.vue";
import workerDetail from "@/components/worker/logDetail.vue";
export default {
  components: {
    changeChannel,
    workerDetail
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      query_field: "",
      is_aexamine: "",
      work_type: "",
      status: "",
      is_relatives_card: "",
      thList: [
        "姓名",
        "手机号码",
        "项目",
        "类型",
        "入职日期",
        "状态",
        "来源类型",
        "来源渠道",
        "渠道详情",
        "操作"
      ],
      resume_source: "",
      is_authentication: "",
      on_job: "",
      formList: [
        { label: "全部", value: -1 },
        {
          label: "芜湖招聘部",
          value: 2
        },
        {
          label: "转介绍",
          value: 1
        },
        {
          label: "自主开发",
          value: 3
        },
        {
          label: "三方公司",
          value: 4
        },
        {
          label: "未知",
          value: 10
        }
      ],
      businessList: [],
      project_id: "",
      userList: [],
      showIsSearch: false,
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      userOperation: false,
      userBoss: false,
      dateVal: null,
      date_type: 1,
      start_date: "",
      end_date: "",
      operation_type: 1,
      operation_user_id: "",
      changeChannelDetail: "",
      is_sign_contract: "",
      showIsWorkerDetail: false,
      entry_id: "",
      is_settlement: "",
      showIsChangeChannel: false,
      statusList: [
        {
          id: "",
          txt: "全部"
        },
        {
          id: 9,
          txt: "待认证"
        },
        {
          id: 10,
          txt: "待签约"
        },
        {
          id: 20,
          txt: "待审核"
        },
        {
          id: 31,
          txt: "资料驳回"
        },
        {
          id: 40,
          txt: "已入职"
        },
        {
          id: 11,
          txt: "新合同待签"
        },
        {
          id: 50,
          txt: "离职合同待签"
        },
        {
          id: 51,
          txt: "已离职"
        }
      ]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目列表
    this.getProOne(); //获取一级项目列表
    this.getUser(); //获取用户
    let roleList = window.localStorage.getItem("xnserve-authority").split(",");
    this.userOperation = roleList.includes("运营支持");
    this.userBoss = roleList.includes("BOSS");
  },
  methods: {
    onDownload() {
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "resume_admin/queryAllEntryLeaveRecordThreeDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&project_id=" +
        pro +
        "&query_field=" +
        this.query_field +
        "&status=" +
        this.status +
        "&is_authentication=" +
        this.is_authentication +
        "&is_sign_contract=" +
        this.is_sign_contract +
        "&is_aexamine=" +
        this.is_aexamine +
        "&on_job=" +
        this.on_job +
        "&work_type=" +
        this.work_type +
        "&resume_source=" +
        this.resume_source +
        "&date_type=" +
        this.date_type +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date +
        "&operation_type=" +
        this.operation_type +
        "&operation_user_id=" +
        this.operation_user_id +
        "&is_relatives_card=" +
        this.is_relatives_card +
        "&is_settlement=" +
        this.is_settlement;
    },
    detailPage(id) {
      this.entry_id = id;
      this.showIsWorkerDetail = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideIsChangeChannel(msg) {
      this.showIsChangeChannel = false;
      if (msg) {
        this.reload();
      }
    },
    changeChannelPage(item) {
      this.showIsChangeChannel = true;
      this.changeChannelDetail = item;
      // console.log(item);
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "contract/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Contract/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    getUser() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/userList";
      let params = {
        per_page: 10000,
        status: 0,
        role_type: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data.data;
          // console.log(this.userList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[0];
    },
    clearSearch() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.date_type = 1;
      this.operation_type = 1;
      this.operation_user_id = "";
      this.resume_source = "";
      this.is_authentication = "";
      this.is_relatives_card = "";
      this.on_job = "";
      this.is_aexamine = "";
      this.project_id = "";
      this.work_type = "";
      this.role_id = "";
      this.selectedOneVal = "";
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.proListTwo = [];
      this.dateVal = null;
      this.is_sign_contract = "";
      this.proListThree = [];
      this.is_settlement = "";
      this.isShowTwo = false;
      this.getPro();
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      let pro = "";
      if (this.selectedThreeVal != "") {
        pro = this.selectedThreeVal;
      } else if (this.selectedTwoVal != "") {
        pro = this.selectedTwoVal;
      } else if (this.selectedOneVal != "") {
        pro = this.selectedOneVal;
      }
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "resume_admin/queryAllEntryLeaveRecordThree";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: pro,
        status: this.status,
        is_authentication: this.is_authentication, //是否实名
        is_sign_contract: this.is_sign_contract, //是否有待签合同
        is_aexamine: this.is_aexamine, //资料是否审核
        on_job: this.on_job, //是否在职
        work_type: this.work_type, //临时工or长期工
        resume_source: this.resume_source, //来源渠道
        date_type: this.date_type, //日期类型
        start_date: this.start_date, //开始日期
        end_date: this.end_date, //结束日期
        operation_type: this.operation_type, //操作人类型
        operation_user_id: this.operation_user_id, //操作人id
        is_relatives_card: this.is_relatives_card, //是否有亲属卡
        is_settlement: this.is_settlement, //离职是否结算
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    showInUserList() {
      this.showIsWorkerDetail = false;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > div {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      > label,
      > div,
      input {
        display: inline-block;
      }
      label {
        margin-right: 10px;
      }
      input {
        width: 200px;
      }
    }
  }
  .projectList {
    margin-bottom: 0;
    li {
      line-height: 20px;
      display: inline-block;
      > label,
      p,
      span {
        font-size: 12px;
        display: inline-block;
      }
    }
  }
  .proListStyle {
    border: none;
    padding: 0;
    td {
      border: none;
      text-align: center;
    }
  }
  .tableStyles {
    table {
      th,
      td {
        text-align: center;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
